import { useState, useEffect, MouseEvent } from "react";
import { Modal, Form, Table, Button } from "react-bootstrap";
import { useAppSelector } from "../../../../redux/hooks";
import { lddGlobalSessionInfo } from "../../../navigationTypes";
import { saveCustomDocumentSet, updateCustomDocumentSet } from "./customDocumentSetFuncs";
import { ClientConnectCustomFieldSet, defaultFieldSet } from "../CustomFieldSets/types";

export type NewCustomFieldSetModalProps = {
    show: boolean;
    onHide: {
        (): void;
        (event: MouseEvent<HTMLButtonElement, MouseEvent>): void;
    };
    editFieldSet: ClientConnectCustomFieldSet,
    fromSettings: boolean
}

const getDefaultFieldSet = (): ClientConnectCustomFieldSet => {
    return {
        ...defaultFieldSet,
        fields: defaultFieldSet.fields.map(field => ({ ...field }))
    };
};


export const NewCustomDocumentSetModal = (props: NewCustomFieldSetModalProps) => {
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [fieldSet, setFieldSet] = useState<ClientConnectCustomFieldSet>(getDefaultFieldSet());
    const [clear, setClear] = useState<boolean>(false);

    useEffect(() => {
        if (props.editFieldSet) {
            setFieldSet(props.editFieldSet)
        } else {
            for (let i = 0; i < fieldSet.fields.length; i++) {
                handleFieldCleared(i)
            }
            setFieldSet(getDefaultFieldSet())
        }
    }, [props.editFieldSet, props.show])


    const handleFieldChange = (index, event) => {
        const newFields = [...fieldSet.fields];
        newFields[index].name = event.target.value;
        setFieldSet({
            ...fieldSet,
            fields: newFields,
        });
    };

    const addNewField = () => {
        const newFields = [...fieldSet.fields, { name: '', type: 'text', perClient: false, value: '', fromSet: true, id: '-1', identifier: '' }];
        setFieldSet({
            ...fieldSet,
            fields: newFields,
        });
    };

    const handleFieldSetNameChange = (event) => {
        const newFieldSetName = event.target.value;
        setFieldSet({
            fieldSetName: newFieldSetName,
            fields: fieldSet.fields,
        })
    }

    const handleFieldCleared = (index) => {
        const newFields = [...fieldSet.fields];
        newFields.splice(index, 1);
        setFieldSet({
            ...fieldSet,
            fields: newFields,
        });
    };

    const handleNewFieldSetSaveClicked = async () => {
        const fSet = { ...fieldSet, fields: fieldSet.fields.filter(f => f.name.trim()) };
        if (fSet.fieldSetName.trim() === '') {
            alert('You must include a document set name.')
        } else if (fSet.fields.length === 0) {
            alert('You must include at least one document.')
        } else {
            let result = props.editFieldSet ? await updateCustomDocumentSet(sessionInfo.sid, fSet, props.editFieldSet) : await saveCustomDocumentSet(sessionInfo.sid, fSet);
            if (result) {
                alert('Successfully Saved');
                setFieldSet(getDefaultFieldSet());
                props.onHide();
            }
        }
    };

    const onHide = () => {
        for (let i = 0; i < fieldSet.fields.length; i++) {
            handleFieldCleared(i)
        }
        props.onHide();
    }

    useEffect(() => {
        if (clear) {
            setFieldSet(getDefaultFieldSet())
            setClear(false)
        }
    }, [clear])


    return (
        <Modal show={props.show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <h2>{props.fromSettings && <>New</>} Document Requests Template {!props.fromSettings && <>(View Only)</>}</h2>
            </Modal.Header>
            <Modal.Body>
                <Form.Label>Document Requests Template Name</Form.Label>
                <Form.Control
                    className="standard-form"
                    name='fieldSetName'
                    value={fieldSet.fieldSetName}
                    onChange={(event) => handleFieldSetNameChange(event)}
                    disabled={!props.fromSettings}
                />
                <br />
                <Table className="table-input" bordered>
                    <thead>
                        <tr>
                            <th>Document Name</th>
                            {/* {fieldSet.fields.length >0 && <th>Per Client</th>} */}
                            {props.fromSettings && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {fieldSet.fields.map((field, index) => {
                            return (
                                <tr key={'new-field-' + index}>
                                    <td>
                                        <Form.Control
                                            className="standard-form"
                                            name='fieldSetName'
                                            value={field.name}
                                            onChange={(event) => handleFieldChange(index, event)}
                                            placeholder="enter a document name.."
                                            disabled={!props.fromSettings}
                                        />
                                    </td>
                                    {props.fromSettings &&
                                        <td style={{ width: '50px' }}>
                                            <Button
                                                variant="link"
                                                onClick={() => handleFieldCleared(index)}
                                            >
                                                <i className="fa-regular fa-trash-can"></i>
                                            </Button>

                                        </td>
                                    }
                                </tr>
                            )
                        })}
                    </tbody>

                    {props.fromSettings &&
                        <tfoot>
                            <tr>
                                <td colSpan={2}>
                                    <Button
                                        variant='link-text'
                                        onClick={() => addNewField()}
                                    >
                                        + Document
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>
                    }
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="link" onClick={() => {
                    onHide();
                }}>
                    Cancel
                </Button>
                {
                    props.fromSettings &&
                    <Button variant="primary" onClick={() => {
                        setFieldSet(getDefaultFieldSet())
                        handleNewFieldSetSaveClicked()
                    }}>
                        Save
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    )
}
